/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/notifications-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/notifications-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/notifications-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-notifications-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/notifications.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-06-29T23:22:39.722Z
 * Source config: config/entities/notifications-entity-config.ts
 * Public fields: 26/26 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const NotificationsSchema = Type.Object({
  id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // id field - primary key
  organization_id: Type.String({ format: "uuid" }), // organization_id field
  user_id: Type.String({ format: "uuid" }), // user_id field
  notification_type_code: Type.String(), // notification_type_code field
  title: Type.String(), // title field
  message: Type.String(), // message field
  importance: Type.Union([Type.String(), Type.Null()]), // importance field
  project_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // project_id field
  job_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // job_id field
  lot_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // lot_id field
  area_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // area_id field
  activity_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // activity_id field
  change_order_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // change_order_id field
  extra_work_order_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // extra_work_order_id field
  inventory_item_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // inventory_item_id field
  purchase_order_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // purchase_order_id field
  document_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // document_id field
  action_url: Type.Union([Type.String(), Type.Null()]), // action_url field
  action_text: Type.Union([Type.String(), Type.Null()]), // action_text field
  is_read: Type.Union([Type.Boolean(), Type.Null()]), // is_read field
  read_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // read_at field
  is_delivered_in_app: Type.Union([Type.Boolean(), Type.Null()]), // is_delivered_in_app field
  is_delivered_email: Type.Union([Type.Boolean(), Type.Null()]), // is_delivered_email field
  is_delivered_sms: Type.Union([Type.Boolean(), Type.Null()]), // is_delivered_sms field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field - auto-managed timestamp
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
});

export const CreateNotificationsSchema = Type.Object({
  organization_id: Type.String({ format: "uuid" }), // organization_id field
  user_id: Type.String({ format: "uuid" }), // user_id field
  notification_type_code: Type.String(), // notification_type_code field
  title: Type.String(), // title field
  message: Type.String(), // message field
  importance: Type.Union([Type.String(), Type.Null()]), // importance field
  project_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // project_id field
  job_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // job_id field
  lot_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // lot_id field
  area_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // area_id field
  activity_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // activity_id field
  change_order_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // change_order_id field
  extra_work_order_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // extra_work_order_id field
  inventory_item_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // inventory_item_id field
  purchase_order_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // purchase_order_id field
  document_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // document_id field
  action_url: Type.Union([Type.String(), Type.Null()]), // action_url field
  action_text: Type.Union([Type.String(), Type.Null()]), // action_text field
  is_read: Type.Union([Type.Boolean(), Type.Null()]), // is_read field
  read_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // read_at field
  is_delivered_in_app: Type.Union([Type.Boolean(), Type.Null()]), // is_delivered_in_app field
  is_delivered_email: Type.Union([Type.Boolean(), Type.Null()]), // is_delivered_email field
  is_delivered_sms: Type.Union([Type.Boolean(), Type.Null()]), // is_delivered_sms field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
});

export const UpdateNotificationsSchema = Type.Object({
  organization_id: Type.String({ format: "uuid" }), // organization_id field
  user_id: Type.String({ format: "uuid" }), // user_id field
  notification_type_code: Type.String(), // notification_type_code field
  title: Type.String(), // title field
  message: Type.String(), // message field
  importance: Type.Union([Type.String(), Type.Null()]), // importance field
  project_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // project_id field
  job_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // job_id field
  lot_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // lot_id field
  area_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // area_id field
  activity_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // activity_id field
  change_order_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // change_order_id field
  extra_work_order_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // extra_work_order_id field
  inventory_item_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // inventory_item_id field
  purchase_order_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // purchase_order_id field
  document_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // document_id field
  action_url: Type.Union([Type.String(), Type.Null()]), // action_url field
  action_text: Type.Union([Type.String(), Type.Null()]), // action_text field
  is_read: Type.Union([Type.Boolean(), Type.Null()]), // is_read field
  read_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // read_at field
  is_delivered_in_app: Type.Union([Type.Boolean(), Type.Null()]), // is_delivered_in_app field
  is_delivered_email: Type.Union([Type.Boolean(), Type.Null()]), // is_delivered_email field
  is_delivered_sms: Type.Union([Type.Boolean(), Type.Null()]), // is_delivered_sms field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type NotificationsRow = Static<typeof NotificationsSchema>;
export type NotificationsInsert = Static<typeof CreateNotificationsSchema>;
export type NotificationsUpdate = Static<typeof UpdateNotificationsSchema>;

// Legacy type aliases for backward compatibility
export type Notifications = NotificationsRow;
export type CreateNotifications = NotificationsInsert;
export type UpdateNotifications = Static<typeof UpdateNotificationsSchema>;

// Field configuration metadata
export const NotificationsFieldConfig = {
  filterable: ['id', 'organization_id', 'user_id', 'project_id', 'job_id', 'lot_id', 'area_id', 'activity_id', 'change_order_id', 'extra_work_order_id', 'inventory_item_id', 'purchase_order_id', 'document_id', 'is_read', 'is_delivered_in_app', 'is_delivered_email', 'is_delivered_sms'] as const,
  sortable: ['created_at'] as const,
  searchable: [] as const,
  required: ['organization_id', 'user_id', 'notification_type_code', 'title', 'message'] as const,
  readonly: ['id', 'created_at'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../../config/search/global-search-config.js';

export interface NotificationsQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface NotificationsResponse {
  data: Notifications[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleNotificationsResponse {
  data: Notifications | null;
  error: Error | null;
}
